const faqItems = [
  {
    q: '51视频需要付费吗？',
    a: '完全免费！51视频是一个影视资源聚合导航平台，所有内容均免费提供。您无需注册、无需会员、无需付费，即可畅享全站高清影视内容。',
  },
  {
    q: '播放会卡顿吗？画质怎么样？',
    a: '51视频采用高速CDN加速技术，绝大多数资源支持1080P高清画质流畅播放，基本不会出现卡顿或缓冲情况。如果偶尔遇到加载问题，可以尝试切换线路。',
  },
  {
    q: '更新速度如何？能看到最新剧集吗？',
    a: '我们7x24小时监控各大平台更新动态，新片上线和剧集更新都会第一时间收录。一般来说，热门剧集播出后几小时内就能在51视频找到高清资源。',
  },
  {
    q: '可以在手机上使用吗？',
    a: '当然可以！51视频完美适配手机、平板和电脑端，无论您使用什么设备，都能获得优质的观影体验。推荐在手机浏览器中添加到主屏幕，使用起来像原生APP一样方便。',
  },
  {
    q: '资源都是从哪里来的？安全吗？',
    a: '51视频聚合了香蕉视频、红桃视频、91视频等多个正规影视平台的公共资源入口，为用户提供一站式的导航服务。我们不存储任何视频文件，仅提供资源入口链接。',
  },
  {
    q: '如何快速找到想看的内容？',
    a: '您可以通过首页的分类导航、排行榜、搜索功能或热门话题标签快速定位到感兴趣的内容。我们也不断优化分类和推荐算法，让您发现更多好片。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-3">常见问题</h2>
          <p className="text-sm text-foreground-600">关于51视频的常见疑问，这里都有解答</p>
        </div>
        <div className="space-y-3">
          {faqItems.map((item, idx) => (
            <details
              key={idx}
              className="group bg-background-50 rounded-lg border border-background-200/70 overflow-hidden"
            >
              <summary className="flex items-center justify-between p-4 md:p-5 cursor-pointer text-sm md:text-base font-medium text-foreground-900 hover:text-primary-600 transition-colors list-none">
                <span>{item.q}</span>
                <div className="w-5 h-5 flex-shrink-0 flex items-center justify-center ml-3">
                  <i className="ri-arrow-down-s-line text-lg group-open:rotate-180 transition-transform duration-200"></i>
                </div>
              </summary>
              <div className="px-4 md:px-5 pb-4 md:pb-5 text-sm text-foreground-600 leading-relaxed">
                {item.a}
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}